import { AuthProvider } from './auth/auth-context';
import { AppRouter } from './routes';
import { QueryProvider } from './shared/lib/query-provider';
import { ThemeProvider } from './theme';

// Provider order: QueryProvider (cache, no DOM) → ThemeProvider (theme + RTL +
// color scheme contexts) → AuthProvider (depends on axios + needs to be inside
// theme so login form errors render styled) → AppRouter (consumes all of the above).

export function App() {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
